import { render, staticRenderFns } from "./Otp.vue?vue&type=template&id=5367f6a1&scoped=true"
import script from "./Otp.vue?vue&type=script&lang=js"
export * from "./Otp.vue?vue&type=script&lang=js"
import style0 from "./Otp.vue?vue&type=style&index=0&id=5367f6a1&prod&lang=css"
import style1 from "./Otp.vue?vue&type=style&index=1&id=5367f6a1&prod&scoped=true&lang=css"
import style2 from "./Otp.vue?vue&type=style&index=2&id=5367f6a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5367f6a1",
  null
  
)

export default component.exports